import { render, staticRenderFns } from "./online-presence-input.vue?vue&type=template&id=a448ff96&lang=pug&"
import script from "./online-presence-input.vue?vue&type=script&lang=js&"
export * from "./online-presence-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports